export const SET_ADMIN_HEADER = 'SET_ADMIN_HEADER';
export const GET_ADMIN_HEADER = 'GET_ADMIN_HEADER';
